// extracted by mini-css-extract-plugin
export var bg = "Hero-module--bg--8ZfSd";
export var cta = "Hero-module--cta--p+psx";
export var img = "Hero-module--img--acRmm";
export var root = "Hero-module--root--X8EBI";
export var title = "Hero-module--title--IOD2-";
export var txt = "Hero-module--txt--ejQKw";